// extracted by mini-css-extract-plugin
export default {"chatbot-container":"KyWQat","chatbotContainer":"KyWQat","move-in-right":"K46WUr","moveInRight":"K46WUr","move-in-left":"up6wve","moveInLeft":"up6wve"};